(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('UploadFileController', UploadFileController);

    UploadFileController.$inject = ['$scope', '$state', 'DataUtils', 'Upload','authExpiredInterceptor','$window'];

    function UploadFileController ($scope, $state, DataUtils, Upload, authExpiredInterceptor,$window) {
        var vm = this;
        var self = $scope;
        vm.import = function() {
			var data = [];
			if (vm.attachment !== undefined
					&& vm.attachment !== null) {
				data['file'] = vm.attachment;
			}
			$scope.loading = true;
			Upload.upload({url : GLOBAL_URL + 'api/master/upload-file?access_token=' + authExpiredInterceptor.getToken(), data : data}).then(function(result) {
				vm.dataImport = result.data;
//				$(window).scrollTop(0);
				if (vm.dataImport.unsuccessfulRow != 0) {
					self.addAlert('Upload file lỗi. Vui lòng xem lại file đã tải về.','danger');
					vm.download(vm.dataImport);
				} else {
					self.addAlert('Upload thành công.', 'success');
				}
			}, function(result) {
				$scope.loading = false;
			}, function(evt) {
				$scope.loading = false;
			});
		};
		vm.removeFileAttach = function(file, errFiles) {
			if (file != undefined && file != null) {
				vm.attachment = file;
			}
		};
		vm.download = function(attach){
			// danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for
				// IE
				// browser
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.fileName);
				} else {
					var blob = new Blob([ attach ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.fileName);
				}
			} else {
				// truong hop file da luu duoi database
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.dataType
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = attach.fileName;
					aTag.click();
				}
			}
		}
    }
})();
